import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper, Container, Avatar } from '@mui/material';
import Logo from "./assets/logo2.png";
import swal from 'sweetalert';
import { useLocation, useNavigate } from 'react-router-dom';

const SignIn = () => {

    const navigate = useNavigate();

    const [email, setEmail] = useState('');

     const [emailError, setEmailError] = useState('');

    const handleEmailChange = (e) => {
  const value = e.target.value;
  setEmail(value);

  // Simple & reliable email regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!value) {
    setEmailError("Email is required");
  } else if (value && !emailRegex.test(value)) {
    setEmailError("Please enter a valid email address");
  } else {
    setEmailError("");
  }
};


    const handleSubmit = async (event) => {
//    navigate("/signin-otp");
        event.preventDefault();

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!email) {
    setEmailError("Email is required");
  } else if (!emailRegex.test(email)) {
    setEmailError("Please enter a valid email address");
  } else {
    setEmailError("");
  }

        if (email) {
            let signinObject = { email: email }
            const url = process.env.REACT_APP_SERVER_URL + "/savyandsons/auth/signin";
            const config = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    // 'Authorization': 'Bearer ' + user.accessToken
                },
                body: JSON.stringify(signinObject)
            };
            try {
                const response = await fetch(url, config);
                const data = await response.json();
                console.log("data" + data);
                if (response.ok)  {
                      console.log("data" + data);
                    
navigate("/signin-otp", {
  state: {
    email: data.email,
    expiresAt: data.expiresAt
  }
});


                }  else if (response.status === 400) {
      setEmailError(data.message); // 👈 shows error under TextField
    }
 else if (response.status === 401) {
                    swal("Username or Password Wrong");
                }else {
      swal("Something went wrong. Please try again.");
    }
            } catch (error) {
                console.error('Error:', error);
            }
        }
    }

    return (
        <>

            <Container
                maxWidth="md"
                component="main"
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: 0, // No margin to fully center it
                    mb: 0,
                    px: { xs: 2, sm: 4 }
                }}
            >

            <Paper
  elevation={0}
  sx={{
    padding: 4,
    borderRadius: 3,
    textAlign: "center",
    width: "100%",
    maxWidth: "400px",

    /* LOGO COLOR TOP → DARKER BOTTOM */
    background: `
      linear-gradient(
        180deg,
        rgba(255, 205, 120, 0.30) 0%,
        rgba(255, 255, 255, 0.92) 55%,
        rgba(0, 0, 0, 0.06) 100%
      )
    `,
    backdropFilter: "blur(6px)",

    border: "1px solid rgba(0,0,0,0.08)",
    boxShadow:
      "0 24px 60px rgba(0,0,0,0.18), 0 6px 14px rgba(0,0,0,0.08)",
  }}
>


                    <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
                        <img src={Logo} alt="Logo" style={{ width: "70%", height: "auto" }} />
                    </Box><br />
                    <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
                        <Typography variant="h4" gutterBottom sx={{ color: '#1E2548', fontWeight: 'bold' }}>
                            Sign In
                        </Typography>  </Box>
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 2 }}>
                        <TextField
                            fullWidth
                            label={<span>Email <span style={{ color: "#1E2548" }}>*</span></span>}
                            variant="outlined"
                            margin="normal"
                            value={email}
                            onChange={handleEmailChange}
                            error={emailError}
                            helperText={emailError}
                        />
                       
                     <Button
  type="submit"
  variant="contained"
  onClick={handleSubmit}
  sx={{
    mt: 3,
    mb: 2,

    px: 4,              // horizontal size
    py: 1.1,            // vertical size (smaller height)
    minHeight: "unset", // remove default MUI height
    width: "100%",      // keep full width (change to auto if needed)

    background: "linear-gradient(135deg, #0d0d0f, #1a1a1d)",
    color: "#ffffff",

    fontSize: 14,
    fontWeight: 700,
    textTransform: "none",
    borderRadius: 2,

    boxShadow: "0 8px 18px rgba(0,0,0,0.35)",

    "&:hover": {
      background: "linear-gradient(135deg, #17171a, #000000)",
      boxShadow: "0 10px 24px rgba(0,0,0,0.45)",
      transform: "translateY(-1px)",
    },

    "&:active": {
      transform: "translateY(0)",
      boxShadow: "0 6px 14px rgba(0,0,0,0.3)",
    },
  }}
>
  Sign In
</Button>

                    </Box>
                </Paper>
            </Container>
        </>
    );
};

export default SignIn;
